import { Link } from "react-router-dom";

export function Landing() {
  return <main className="landing">
    <header className="landing-topo">
      <Link to="/" className="landing-marca">Vistoria<span>Gestão</span></Link>
      <nav aria-label="Navegação institucional"><a href="#como-funciona">Como funciona</a><a href="#recursos">Recursos</a></nav>
      <Link className="landing-entrar" to="/entrar">Entrar</Link>
    </header>

    <section className="landing-hero">
      <div className="landing-hero-texto">
        <p className="landing-eyebrow">GESTÃO DE VISTORIAS PREDIAIS</p>
        <h1>Vistoria feita.<br /><i>Providência acompanhada.</i></h1>
        <p className="landing-intro">Transforme o que foi visto em campo em tarefas claras, responsáveis definidos e uma visão que o gestor entende de primeira.</p>
        <div className="landing-acoes"><Link className="landing-cta" to="/entrar">Acessar a plataforma <span>→</span></Link><a className="landing-link" href="#como-funciona">Ver como funciona</a></div>
        <div className="landing-prova"><span>Feito para</span><strong>administradoras · síndicos · equipes de vistoria</strong></div>
      </div>
      <div className="landing-cena" aria-label="Exemplo de acompanhamento de uma vistoria">
        <div className="landing-cena-faixa"><span>VISTORIA EM CAMPO</span><strong>17 AGO · LE PARC 2</strong><i>Concluída</i></div>
        <div className="landing-cena-corpo">
          <div className="landing-cena-titulo"><span>02</span><div><small>OCORRÊNCIAS IDENTIFICADAS</small><strong>Casa de bombas</strong></div></div>
          <div className="landing-ponto aberto"><b>!</b><div><strong>Painel elétrico</strong><span>Correção necessária</span></div><em>Aberta</em></div>
          <div className="landing-fluxo"><span></span><small>gera uma tarefa</small></div>
          <div className="landing-tarefa"><div><small>TAREFA</small><strong>Regularizar painel elétrico</strong><span>Responsável: manutenção</span></div><i>Em execução</i></div>
        </div>
        <div className="landing-cena-rodape"><span>Uma linha de ação, do apontamento à verificação.</span><b>↗</b></div>
      </div>
    </section>

    <section className="landing-ciclo" id="como-funciona">
      <div><p className="landing-eyebrow">DA VISITA À RESOLUÇÃO</p><h2>O trabalho não termina quando a vistoria é entregue.</h2></div>
      <ol>
        <li><span>01</span><div><strong>Vistorie no local</strong><p>Checklists organizados para registrar o que realmente importa.</p></div></li>
        <li><span>02</span><div><strong>Transforme achados em ação</strong><p>Não conformidades viram tarefas com prioridade e responsável.</p></div></li>
        <li><span>03</span><div><strong>Verifique a próxima visita</strong><p>O histórico volta para campo até que cada ponto seja resolvido.</p></div></li>
      </ol>
    </section>

    <section className="landing-recursos" id="recursos">
      <div className="landing-recursos-intro"><p className="landing-eyebrow">UMA OPERAÇÃO CONECTADA</p><h2>Menos planilhas soltas.<br />Mais previsibilidade.</h2><p>Um lugar para organizar vistorias, evidências, pendências e tarefas — sem perder o contexto de onde cada demanda nasceu.</p></div>
      <div className="landing-recursos-grade">
        <article className="landing-recurso landing-recurso-destaque"><span>⌁</span><small>NO CAMPO</small><h3>Checklist que acompanha a vistoria.</h3><p>Registre conformidades, não conformidades e evidências no mesmo fluxo.</p></article>
        <article className="landing-recurso"><span>↳</span><h3>Pendências com origem clara</h3><p>Todo apontamento mantém sua ligação com a vistoria e o prédio.</p></article>
        <article className="landing-recurso"><span>✓</span><h3>Tarefas que viram verificação</h3><p>A conclusão da tarefa volta para campo na próxima visita.</p></article>
      </div>
    </section>

    <section className="landing-fechamento"><p className="landing-eyebrow">PRONTO PARA ORGANIZAR A OPERAÇÃO?</p><h2>Dê continuidade ao que a vistoria encontrou.</h2><Link className="landing-cta" to="/entrar">Entrar na plataforma <span>→</span></Link></section>
    <footer className="landing-rodape"><span>Vistoria Gestão</span><span>Gestão de vistorias prediais</span></footer>
  </main>;
}
